import React from 'react';
import ExploreLayout from '../components/ExploreLayout';
import ExploreMission from '../components/ExploreMission';
import ExploreSuccess from '../components/ExploreSuccess';

export default function ExploreMorpheusPage() {
  return (
    <ExploreLayout
      stepId="morpheus"
      eyebrow="Morpheus Experience"
      title="Find the stock problem."
      subtitle="This placeholder prepares the Morpheus mission path: count, variance, ownership, cycles and response intelligence."
      nextLabel="Continue to Link"
    >
      <div className="explore-split">
        <ExploreMission
          title="Mission: Investigate variance"
          description="The demo operation completed a section count. Your job is to find where accountability lives."
          tasks={[
            'Choose a cycle and section',
            'Review the counted products',
            'Find the variance owner',
            'Trigger the manager response',
          ]}
        />
        <div className="explore-console">
          <div className="explore-console-header">
            <span>Morpheus Accountability</span>
            <strong>Morning Count</strong>
          </div>
          <div className="explore-console-screen">
            <div className="explore-console-row"><span>Kitchen Variance</span><strong>-R4,500</strong></div>
            <div className="explore-console-row"><span>Previous Count</span><strong>-R3,800</strong></div>
            <div className="explore-console-row"><span>Trend</span><strong>Worsening</strong></div>
            <div className="explore-console-row"><span>Owner</span><strong>Kitchen Lead</strong></div>
          </div>
        </div>
      </div>
      <ExploreSuccess title="Morpheus path ready" description="Future sprints can plug the real demo count flow into this shell." />
    </ExploreLayout>
  );
}
